import { CService } from "./class.base.service";

class CompanyService extends CService{
  getProductCategories<T = any>(params: any) {
    return this.api.get<any, T>('product-categories', { params })
  }
}

const companyService = new CompanyService("companies");
export default companyService